import React from "react";
import { Card } from "react-bootstrap";
import FalconCardHeader from "components/common/FalconCardHeader";

const PyramidCard = ({
  title,
  children,
  className = "",
  noPadding = false,
}) => {
  return (
    <Card className={className}>
      {title && (
        <FalconCardHeader title={title} titleTag="h5" className="py-1 mt-2" />
      )}
      <Card.Body className={noPadding ? "p-0" : "py-2"}>{children}</Card.Body>
    </Card>
  );
};

export default PyramidCard;
